import { Component, OnInit } from '@angular/core';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { LegalDataProviderService } from 'src/app/___LOGIC/__data/__apps/legal-data-provider.service';

@Component({
  selector: 'app-legal-helper',
  templateUrl: './legal-helper.component.html',
  styleUrls: ['./legal-helper.component.css']
})
export class LegalHelperComponent implements OnInit {

  /* Photo by <a href="https://unsplash.com/@gabriellefaithhenderson?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Gabrielle Henderson</a> on <a href="https://unsplash.com/photos/woman-signing-on-white-printer-paper-beside-woman-about-to-touch-the-documents-HJckKnwCXxQ?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> */
      
  introSection = {
    title: 'Asistente Legal',
    imageUrl: this.guiFlow.getWorkerImage('servicios-legal-2.png','public'),
    subtitle: 'Bienvenido al Asistente Legal. Aquí encontrarás información y asistencia sobre los procesos legales más comunes en España, como renovaciones de visados, permisos de trabajo y más.',
    shortPara: '¿Necesitas ayuda legal personalizada? Reserva una sesión con nuestro equipo de expertos y obtén la asesoría que necesitas.',
    description: 'Bienvenido al Asistente Legal. Aquí encontrarás información y asistencia sobre los procesos legales más comunes en España, como renovaciones de visados, permisos de trabajo y más.',
    array: [],
  }

  reservaSesion = {};
  renovacionVisado = {};
  permisoTrabajo = {};

  constructor(private guiFlow: GuiFlowService,private legalDataService: LegalDataProviderService) { }

  ngOnInit(): void {
    this.renovacionVisado = this.legalDataService.getRenovacionData();
    this.permisoTrabajo = this.legalDataService.getPermisoTrabajoData();
    this.reservaSesion = this.legalDataService.getReservarSesion();
   }

  bookLegalSession() {
    debugger
    // Logic for booking a legal session
    alert("Legal session booked successfully!");
  }

}
